import tippy from 'tippy.js'
import { initTooltip } from './helpers'

const descriptionListIs =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('../../../../Vettvangur.Site/wwwroot/scripts/libs/tooltips.is-is').descriptionList

const descriptionListEn =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('../../../../Vettvangur.Site/wwwroot/scripts/libs/tooltips.en-us').descriptionList

const url = window.location.href
const descriptionList = url.match('/en/') ? descriptionListEn : descriptionListIs

const richtextTooltip = {
  el: {
    sections: document.querySelectorAll('.canContainTooltipWords'),
  },

  init() {
    if (this.el.sections) {
      this.el.sections.forEach((section) => {
        this.getTooltips(section)
      })
    }
  },

  getTooltips: (section: Element) => {
    const text = section.innerHTML
    const tooltipWords = [] as Array<string>
    const tooltipMatches = text.match(/#(.*?)#/g)

    if (tooltipMatches !== null) {
      tooltipMatches.map(function (val) {
        const word = val.replace(/#/g, '') as string

        if (!tooltipWords.includes(word)) {
          tooltipWords.push(word)
        }
      })
    }

    if (tooltipWords.length > 0) {
      richtextTooltip.createTooltip(tooltipWords, section)
    }

    const tooltips = section.querySelectorAll('.richtext-tooltip')
    tooltips.forEach((tooltip) => {
      initTooltip(tooltip)
    })
  },

  createTooltip(words: Array<string>, section: Element) {
    let text = section.innerHTML

    for (let i = 0, l = words.length; i < l; i++) {
      const selectedWord = `#${words[i]}#`
      const descriptionListObj = this.getDescriptionListObj(words[i])

      if (descriptionListObj.length < 1 || descriptionListObj === undefined) {
        text = text.replace(selectedWord, function () {
          return `<span>${words[i]}</span>`
        })
      } else {
        text = text.replace(selectedWord, function () {
          return `<span class="richtext-tooltip" data-tippy-content="${descriptionListObj[0].Description}">${words[i]}</span>`
        })
      }
    }

    section.innerHTML = text
  },

  getDescriptionListObj(word: string) {
    return descriptionList.filter((obj) => {
      return obj.Word === word
    })
  },
}

export default richtextTooltip
